<template>
  <div class="xm-sidebar">
    <div
      v-for="route in realMenus"
      :key="route.title"
    >
      <!-- 工时中心是mall-v2的项目，新开页跳转 -->
      <a
        v-if="route.external"
        :href="route.path"
        target="_blank"
        rel="noopener"
      >
        {{ route.title }}
      </a>
      <router-link
        v-else
        :to="route.path"
      >
        {{ route.title }}
      </router-link>
    </div>
  </div>
</template>
<script>
  import I18n from '@i18n'
  import { mapGetters } from 'vuex'
  
  // 台湾和香港都是okki.com域名
  const isOkki = window.location.href.includes('okki.com');
  const MENUS = [
    {
      title: I18n.t('sideBar.home'),
      name: '',
      path: '/home',
      index: '1',
    },
    {
      title: I18n.t('sideBar.buy'),
      name: '',
      path: '/store',
      index: '2',
      hideInHKOrTW: true,
    },
    {
      title: I18n.t('sideBar.order'),
      name: '',
      path: '/order',
      index: '3',
    },
    {
      title: I18n.t('sideBar.voucher'),
      name: '',
      path: '/voucher',
      index: '4',
      hideInHKOrTW: true,
    },
    {
      title: I18n.t('sideBar.invoice'),
      name: '',
      path: '/invoice',
      index: '5',
      hideInTW: true,
    },
    {
      title: I18n.t('sideBar.worktime'),
      name: '',
      path: '/worktime/',
      index: '6',
      // 仅大陆售卖，且仅主账号可见
      hideInHKOrTW: true,
      adminOnly: true,
      external: true,
    },
  ]

  // 菜单可见性：命中任一隐藏规则就不展示
  const isMenuVisible = (menu, { isTWClient, isAdmin }) => {
    if (menu.hideInHKOrTW && isOkki) {
      // 港台站点隐藏
      return false
    }
    if (menu.hideInTW && isTWClient) {
      // 台湾客户隐藏
      return false
    }
    if (menu.adminOnly && !isAdmin) {
      // 仅主账号可见
      return false
    }
    return true
  }

  export default {
    data () {
      return {
        selected: ['1'],
      }
    },
    computed: {
      ...mapGetters('main', ['isTWClient', 'isAdmin']),
      realMenus() {
        return MENUS.filter(menu => isMenuVisible(menu, this))
      }
    },
    watch: {
      '$route'(route) {
        const currentPath = route.path
        MENUS.forEach(menu => {
          const pathReg = new RegExp(menu.path)
          if (pathReg.test(currentPath)) {
            this.selected = [menu.index]
            return
          }
        })
      }
    },
    methods: {
      onClick(menu) {
        this.selected = [menu.index]
        this.$router.push(menu.path)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .xm-sidebar{
    position: fixed;
    top: 66px;
    z-index: 29;
    width: 200px;
    height: calc(100vh - 66px);
    margin-left: -200px;
    border-right: 1px solid #b6b6b6;
    background: #fff;
    a{
      display: block;
      padding: 0 20px;
      font-size: 14px;
      line-height: 40px;
      color: #444;
      &:hover{
        background-color: #f0f0f0;
        text-decoration: none !important;
      }
      &.router-link-active{
        color: #0884f3;
        background: #ecf4fd;
      }
    }
  }
</style>

